import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import CryptoJS from "crypto-js";
import axios from "axios";
import CareHealthKYC from "./CareHealthKYC/CareHealthKYC";
import StarHealthKYC from "./StarHealthKYC/StarHealthKYC";
import CategoryHeader from "../Components/Headers/CategoryHeader";
import HdfcHealthKYC from "./HdfcErgoKYC/HdfcHealthKYC";
import { getLocalData } from "../Utilities/Common/source";
import axiosInstance from "../Utilities/djangoAxiosInstance";

const AgentVerification = () => {
  const [next, setNext] = useState(true);
  const [quickQuoteDetails, setQuickQuoteDetails] = useState({});

  let navigate = useNavigate();

  const { productId } = useParams();

  const productIdArray = productId.split("*");
  const productRef = productIdArray[0];
  const responseId = productIdArray[1];
  const Acuvisor_product_id = productIdArray[2];

  const productRefURI = decodeURIComponent(productRef).toString();
  const responseIdURI = decodeURIComponent(responseId).toString();
  const Acuvisor_product_idURI =
    decodeURIComponent(Acuvisor_product_id).toString();

  const bytesProductRefURI = CryptoJS.AES.decrypt(
    productRefURI,
    "secret key @123"
  );
  const bytesResponseIdURI = CryptoJS.AES.decrypt(
    responseIdURI,
    "secret key @124"
  );
  const bytesAcuvisor_product_idURI = CryptoJS.AES.decrypt(
    Acuvisor_product_idURI,
    "secret key @124"
  );

  const decryptedProductRef = JSON.parse(
    bytesProductRefURI.toString(CryptoJS.enc.Utf8)
  );
  const decryptedResponseId = JSON.parse(
    bytesResponseIdURI.toString(CryptoJS.enc.Utf8)
  );
  const decryptedAcuvisor_product_id = JSON.parse(
    bytesAcuvisor_product_idURI.toString(CryptoJS.enc.Utf8)
  );

  const localSource = getLocalData("source");
  console.log("agentVerification localSource: ", localSource);
  console.log("kkk", decryptedAcuvisor_product_id);
  console.log(productIdArray);

  const nextHandler = () => {
    // console.log('states',CKYC,EKYC)
    let path = "";
    let encryptedProduct_ref = encodeURIComponent(
      CryptoJS.AES.encrypt(
        JSON.stringify(decryptedProductRef),
        "secret key @123"
      ).toString()
    );
    let encryptedDataId = encodeURIComponent(
      CryptoJS.AES.encrypt(
        JSON.stringify(decryptedResponseId),
        "secret key @124"
      ).toString()
    );

    path = `/health-insurance/product/${encryptedProduct_ref}*${encryptedDataId}`;
    navigate(path);
  };

  const goBack = () => {
    navigate(-1);
  };

  const renderProductKYC = () => {
    console.log("renderProductEKYC is called: ", decryptedAcuvisor_product_id);
    switch (Number(decryptedAcuvisor_product_id)) {
      case 33333:
        return CareKYC();
        break;
      case 33222:
        return CareKYC();
        break;
      case 33111:
        return CareKYC();
        break;
      case 70001:
        return StarKYC();
        break;
      case 70015:
        return StarKYC();
        break;
      case 70018:
        return StarKYC();
        break;
      case 15032301:
        return HdfcKYC();
        break;
      case 15032302:
        return HdfcKYC();
        break;
      case 15032303:
        return HdfcKYC();
        break;
      case 15032304:
        return HdfcKYC();
        break;
      case 65032301:
      case 65032302:
      case 55032301:
      case 55032302:
      case 31072023:
        return HdfcKYC();
      default:
        return <>Oops !</>;
    }
  };

  const CareKYC = () => {
    return (
      <CareHealthKYC
        decryptedProductRef={decryptedProductRef}
        decryptedResponseId={decryptedResponseId}
        decryptedAcuvisor_product_id={decryptedAcuvisor_product_id}
        quickQuoteDetails={quickQuoteDetails}
        setNext={setNext}
      />
    );
  };
  const StarKYC = () => {
    // console.log("================================")
    return (
      <>
        <StarHealthKYC
          setParentNext={setNext}
          kyc_configId={quickQuoteDetails.kyc_form_config_id}
          a_id={quickQuoteDetails.A_id}
          decryptedResponseId={decryptedResponseId}
          decryptedAcuvisor_product_id={decryptedAcuvisor_product_id}
        />
      </>
    );
  };

  const HdfcKYC = () => {
    return (
      <HdfcHealthKYC
        decryptedProductRef={decryptedProductRef}
        decryptedResponseId={decryptedResponseId}
        decryptedAcuvisor_product_id={decryptedAcuvisor_product_id}
        setNext={setNext}
        a_id={quickQuoteDetails.A_id}
      />
    );
  };

  useEffect(() => {
    let domain = "";
     

    axiosInstance
      .get(`api/health/transfer-data/${decryptedResponseId}`, {
        params: {
          source: localSource,
        }
      })
      .then((response) => {
        if (response.status === 200) {
          console.log("response from djamgoo ", response);
          setQuickQuoteDetails(response.data);
        }
      });
  }, []);

  return (
    <div>
      <div className=" ">
        <CategoryHeader title="Health Insurance" />
      </div>
      <div>{renderProductKYC()}</div>

      <div className=" btn-sec  position-fixed bottom-0 ">
        <button className="reset-btn text-capitalize" onClick={goBack}>
          Go Back
        </button>
        <button
          className="submitBtn text-capitalize "
          onClick={nextHandler}
          disabled={next}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default AgentVerification;
